export default "__VITE_PUBLIC_ASSET__2a5d4cc5__"